export default __webpack_public_path__ + "static/media/Laws.da16051e.svg";